<template>
  <div class="admissionExpensesDetail">
    <!-- 账单详情页面 -->
    <el-row>
      <el-col :span="10">
        <el-button type="primary" plain @click="back">返回</el-button>
        <el-button type="info" plain @click="downBill">打印账单</el-button>
      </el-col>
      <el-col :span="14" class="intoDetail">
        <span>{{ billTypeName }}</span>
      </el-col>
    </el-row>
    <el-container class="baseDetail">
      <el-header class="header">
        <div class="react"></div>
        <span>基本信息</span>
      </el-header>
      <el-row type="flex" justify="space-around" style="padding-bottom:12px">
        <el-col :span="6">
          <p>
            费用单号: <span>{{ billDetail.billNumber }}</span>
          </p>
          <p>
            老人姓名: <span>{{ billDetail.oldName }}</span>
          </p>
          <p>
            身份证号: <span>{{ billDetail.idCard }}</span>
          </p>
          <p v-if="billType == 5">
            请假日期: <span>{{ oldLeaveVo.leaveDate }}</span>
          </p>

        </el-col>
        <el-col :span="4">
          <p v-if="billType == 4">
            性别: <span>{{ billDetail.sex == 0 ? "男" : "女" }}</span>
          </p>
          <p v-if="billType != 4">
            账单日期: <span>{{ oldOutVo.leaveDate}}</span>
          </p>
          <p v-if="billType != 2">
            床位号: <span>{{ billDetail.newBedNo }}</span>
          </p>
          <p v-if="billType == 1">
            押金编号: <span>{{ billDetail.cashPledgeNum }}</span>
          </p>
          <P v-if="billType != 1">
            入院时间: <span>{{ billDetail.intoDate }}</span>
          </P>
          <P v-if="billType == 2">
            出院日期: <span>{{ oldOutVo.leaveDate }}</span>
          </P>
          <p v-if="billType == 5">
            回院日期: <span>{{ oldLeaveVo.returnDate }}</span>
          </p>
        </el-col>
      </el-row>
    </el-container>

    <!-- 入院时间 -->
    <el-container class="intoTime" v-if="billType == 1">
      <el-header class="header">
        <div class="react"></div>
        <span>入院时间</span>
      </el-header>
      <el-row type="flex" justify="center" style="height:64px;">
        <el-col :span="16">
          <p>
            入院时间： <span>{{ billDetail.intoDate }}</span>
          </p>
        </el-col>
      </el-row>
    </el-container>
    <!-- type == 1 入院 -->
    <!-- 缴费记录单 -->
    <div v-if="billType == 1" style="margin-bottom:20px">
      <el-table
        :data="billItemList"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        style="width:100%;margin-top:40px"
      >
        <el-table-column label="入院项目" align="center">
          <el-table-column
            prop="itemType"
            label="缴费类别"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemName"
            label="费用项目"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemFee"
            label="项目费用"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="costType"
            label="扣费频次"
            :formatter="formatterCost"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="actualFee"
            label="实际费用"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>

      <el-table
        :data="PeriodicItems"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        style="width:100%;margin-top:40px"
      >
        <el-table-column label="周期消费项目" align="center">
          <el-table-column
            prop="itemType"
            label="费用类别"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemName"
            label="费用项目"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemFee"
            label="项目费用"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="costType"
            label="扣费频次"
            :formatter="formatterCost"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="actualFee"
            label="实际费用"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>


      <el-table
        :data="totalFeeList"
        style="width:100%;margin-top:40px"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column label="应缴合计" align="center">
          <el-table-column
            prop="payDay"
            label="本月剩余天数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="totalDay"
            label="总计费天数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="onceFee"
            label="一次性项目金额"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="totalFee"
            label="总金额"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>
      <el-row style="margin-top:20px;padding-bottom:20px" v-if="!isPay">
        <el-button type="primary" style="margin-left:46.5%" plain @click="confBill">确认账单</el-button>
      </el-row>

    </div>

    <!-- type == 2 出院 -->
    <!-- 应缴项 -->
    <div v-if="billType == 2" style="margin-bottom:20px">
      
      <el-table
        :data="oldOutItemVoList"
        style="width:100%;margin-top:40px"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column label="应缴项" align="center">
          <el-table-column
          prop="itemType"
          label="费用类别"
          align="center"
        ></el-table-column>
          <el-table-column
            prop="itemName"
            label="应缴项"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemFee"
            label="项目费用"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="costType"
            label="扣费频次"
            :formatter="formatterCost"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="actualFee"
            label="缴费金额"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>

      <!-- 退款项 -->
      <el-table
        :data="tuiFee"
        style="width:100%;margin-top:40px"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column label="退款项" align="center">
          <el-table-column
          prop="itemType"
          label="费用类别"
          align="center"
        ></el-table-column>
          <el-table-column
            prop="itemName"
            label="退款项"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemFee"
            label="项目费用"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="costType"
            label="扣费频次"
            :formatter="formatterCost"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="actualFee"
            label="退费金额"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>

      <!-- 合计 -->
      <el-table
        :data="outTotal"
        style="width:100%;margin-top:40px"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle">
        <el-table-column label="合计" align="center">
          <el-table-column
            prop="tuiDay"
            label="退费天数 "
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemsTotal"
            label="退费总额"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="remainder"
            label="退费前余额"
            v-if="outTotal!=null && outTotal.length>0 &&outTotal[0].remainder!=null && outTotal[0].remainder>=0"
            align="center"
          ></el-table-column>
          
          <el-table-column
            prop="totalPay"
            label="退费前欠缴"
            v-if="outTotal!=null && outTotal.length>0 && outTotal[0].remainder!=null && outTotal[0].remainder<0"
            align="center">
            <template slot-scope="scope">
              <p>{{0 - scope.row.remainder}}</p>
            </template>
          </el-table-column>

          <el-table-column
            prop="totalPay"
            label="退费合计"
            v-if="outTotal!=null && outTotal.length>0 && outTotal[0].totalPay>=0"
            align="center">
          </el-table-column>
          <el-table-column
            prop="totalPay"
            label="欠缴合计"
            v-if="outTotal!=null && outTotal.length>0 && outTotal[0].totalPay<0"
            align="center">
            <template slot-scope="scope">
              <p>{{0 - scope.row.totalPay}}</p>
            </template>
          </el-table-column>

        </el-table-column>
      </el-table>

      <el-row style="margin-top:20px;padding-bottom:20px" v-if="!isPay">
        <el-button type="primary" style="margin-left:46.5%" plain @click="confBill">确认账单</el-button>
      </el-row>

    </div>

    <!-- type == 3 调整账单 -->
    <div v-if="billType == 3" style="margin-bottom:20px">
      <!-- 调整前 -->
      <el-table
        :data="billItemBeforeList"
        style="width:100%;margin-top:40px"
       :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column label="调整前缴费单" align="center">
          <el-table-column
            prop="itemType"
            label="费用类别"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemName"
            label="费用项目"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemFee"
            label="项目费用"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="costType"
            label="扣费频次"
            :formatter="formatterCost"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="actualFee"
            label="实际费用"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>

      <!-- 调整后 -->
      <el-table
        :data="billItemAfterList"
        style="width:100%;margin-top:40px"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column label="调整后缴费单" align="center">
          <el-table-column
            prop="itemType"
            label="费用类别"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemName"
            label="费用项目"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemFee"
            label="项目费用"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="costType"
            label="扣费频次"
            :formatter="formatterCost"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="actualFee"
            label="实际费用"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>

      <!-- 应缴合计 -->
      <el-table
        :data="billAdjustFee"
        style="width:100%;margin-top:40px"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column label="应缴合计" align="center">
          <el-table-column
            prop="payDay"
            label="补缴天数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="totalDay"
            label="总天数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="payableFeeBalance"
            label="调整差额"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="totalFee"
            label="应缴合计"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>
      <el-row style="margin-top:20px;padding-bottom:20px" v-if="!isPay">
        <el-button type="primary" style="margin-left:46.5%" plain @click="confBill">确认账单</el-button>
      </el-row>
    </div>

    <!-- type == 4 周期账单 -->
    <div v-if="billType == 4" style="margin-bottom:20px">
      <!-- 本周期缴费项目列表 -->
      <el-table
        :data="billItemList"
        style="width:100%;margin-top:40px"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column label="本月费用明细" align="center">
          <el-table-column
            prop="itemType"
            label="费用类别"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemName"
            label="费用项目"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemFee"
            label="项目单价"
            align="center"
            :formatter="eleFeeChange"
          ></el-table-column>
          <el-table-column
            prop="amount"
            label="频次"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="actualFee"
            label="实际费用"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>

      <!-- 周期应缴合计 -->
      <el-table
        :data="billPeriodFee"
        style="width:100%;margin-top:40px"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column label="本月费用表" align="center">
          <el-table-column
            prop="theWeekPayFee"
            label="本月缴费金额"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="lastWeekBackFee"
            label="退费金额"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="totalFee"
            label="实际总金额"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="afterProduceBalance"
            label="剩余金额"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </div>

    
  <!-- type == 5 请假退费 -->
    <!-- 请假退费 -->
    <div v-if="billType == 5" style="margin-bottom:20px">
      <el-table
        :data="billItemList"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        style="width:100%;margin-top:40px"
      >
        <el-table-column label="退费项目" align="center">
          <el-table-column
            prop="itemType"
            label="缴费类别"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemName"
            label="费用项目"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemFee"
            label="项目费用"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="costType"
            label="扣费频次"
            :formatter="formatterCost"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="actualFee"
            label="实际费用"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>

      <el-table
        :data="totalFeeList"
        style="width:100%;margin-top:40px"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column label="退费合计" align="center">
          <el-table-column
            prop="leaveDate"
            label="请假日期"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="returnDate"
            label="回院日期"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="payDay"
            label="退费天数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="totalFee"
            label="退费金额"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>
      <el-row style="margin-top:20px;padding-bottom:20px"  v-if="!isPay || isPay==0">
        <el-button type="primary" style="margin-left:46.5%" plain @click="confBill">确认账单</el-button>
      </el-row>

    </div>

     <!-- 信息确认单 -->
    <el-dialog
     title="账单金额确认"
     :visible.sync="MoneyDialogVisible"
     width="25%"
     :close-on-click-modal="false"
     :close-on-press-escape="false"
     center
   >
     <el-form label-width="100px" class="demo-ruleForm">
        <div v-if="billType == 3 || billType == 5"> 
          <p style="text-align: center; font-size: 18px">
            请确认并核对金额
          </p>
          <el-form-item label="实际金额" style="margin-top:20px">
            <el-input
              style="width: 80%"
              placeholder="请输入实际金额"
              v-model.trim="moneyFee"
              @input="inputNumChange"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="billType == 2"> 
          <p style="text-align: center; font-size: 18px">
            请确认退费总额
          </p>
          <el-form-item label="退费总额" style="margin-top:20px">
            <el-input
              style="width: 80%"
              placeholder="请输入实际金额"
              v-model.trim="moneyFee"
              @input="inputNumChange"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </div>
        <div v-else-if="billType == 1"> 
          <p style="text-align: center; font-size: 18px">
            请确认并核对押金编号
          </p>
          <el-form-item label="押金编号" style="margin-top:20px" >
            <el-input
              style="width: 80%"
              placeholder="请输入押金编号"
              v-model.trim="moneyId"
              onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </div>
        <div v-else-if="billType == 4"> 
          <p style="text-align: center; font-size: 18px">
            请确认并核对票据号
          </p>
          <el-form-item label="收费票据号" style="margin-top:20px" >
            <el-input
              style="width: 80%"
              placeholder="请输入收费票据号"
              v-model.trim="moneyId"
              onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </div>
     </el-form>
     <span slot="footer" class="dialog-footer">
       <el-button @click="MoneyDialogVisible = false">取 消</el-button>
       <el-button type="primary" @click="addBill">确 定</el-button>
     </span>
   </el-dialog>

  </div>
</template>
<script>
import bus from "@/vuex/eventBus";
import { baseURL } from "@/utils/request.js";
export default {
  name: "admissionExpensesDetail",
  components: {},
  data() {
    return {
      billType: 0,
      billTypeName: "",
      intoDate: "",
      oldmanDetail: {}, //老人详情
      isPay:true,
      //入院
      PeriodicItems: [],
      billDetail: [], // 账单详情
      oldLeaveVo:{},
      billItemList: [], //缴费类别
      billMealList: [], //套餐
      mealDetail: [], //套餐详情
      billInHospitalFee: [], //入院费用账单统计
      //出院
      moneyFee:"",
      moneyId:"",
      oldOutVo:{},
      MoneyDialogVisible:false,
      oldOutMeal: [],
      outTotal: [], //合计
      oldOutItemVoList: [], //应缴项
      tuiFee: [], //退款项
      //调整账单
      totalFeeList:[],
      billTotalFee:"",
      billItemBeforeList: [], //调整前
      billSetMealItemList: [], //套餐
      billItemAfterList: [], //调整后
      billAdjustFee: [], //应缴合计
      //周期账单
      billPeriodFee: [], //周期应缴合计
      billType: "", // 账单类型
      billId: "", // 账单id
      billSex: "", // 账单对应老人性别
      oldManId: ""
    };
  },
  methods: {
    confBill(){
      if(this.isPay){
        return;
      }
      this.MoneyDialogVisible = true;
      this.moneyFee = this.totalFeeList[0].totalFee;
      this.moneyId = "";
    },
    addBill(){

      let params = {
        billId: this.billId,
        payFee: this.moneyFee,
        cashPledgeNum: this.moneyId
      };
      this.$postJson("omc/bill/payFee", params).then((res) => {
        if (res.code == 200) {
          this.MoneyDialogVisible = false;
          this.$message({ message: res.message, type: "success" });
          setTimeout(()=>{
            bus.$emit("changeOldListStatus");
            bus.$emit("close_current_tags");
          },200)
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });

    },
    inputNumChange(val) {
      //限制输入数字和两位小数;
      this.moneyFee = val.replace(/[^0-9.]/g, '').replace(/^\D*(\d*(?:.\d{0,2})?).*$/g, '$1')
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    /* 
        返回缴费记录单
      */
    back() {
      bus.$emit("close_current_tags");
    },
    eleFeeChange(row, column) {
      if (row.itemFee == 0 && row.actualFee > 0) {
        return row.actualFee;
      } else {
        return row.itemFee;
      }
    },
    // 打印缴费记录单
    downBill() {
      var Url = "";
      var params = "";
      if (this.billType == 1) {
        //  入院账单
        Url = "omc/auth/dfc/checkInBill/down";
        params = `?id=${this.billId}`;
      } else if (this.billType == 2) {
        //  出院账单
        Url = "omc/auth/dfc/checkOutBill/down";
        params = `?id=${this.billId}`;
      } else if (this.billType == 3) {
        // 调整账单
        Url = "omc/auth/dfc/reviseBill/down";
        params = `?id=${this.billId}&sex=${this.billSex}`;
      } else if (this.billType == 4) {
        // 周期账单
        Url = "omc/auth/dfc/cycleBill/down";
        params = `?id=${this.billId}`;
      }
      window.location.href = baseURL + Url + params;
    },
    
    formatterCost(row){
      let costType = "";
      if (row.costType == 1) {
        costType = "元/次";
      } else if (row.costType == 2) {
        costType = "元/天";
      } else if (row.costType == 3) {
        costType = "元/月";
      } else if (row.costType == 4) {
        costType = "元/年";
      } else if (row.costType == 5) {
        costType = "元/一次性";
      }
      return costType;
    },
    /* 
      根据老人ID和账单类型查询账单详情
     */
    getOldmanBillDetail(oldManId, billType, billId) {
      this.$postForm("omc/bill/queryBillById/" + billId).then(res => {
        this.isPay = res.result.omcOldManBill.isPay == 0?false:true;
        if (this.billType == 1) {
          this.billDetail = res.result.omcOldManBillDetailVo;
          this.billDetail.intoDate = res.result.omcOldManBill.inDate;
          this.billDetail.intoDate = res.result.omcOldManBill.inDate;
          this.billDetail.createdDay =res.result.omcOldManBill.createdTime.split(" ")[0];
          this.totalFeeList = [];
          //入院
          if (res.result.omcOldManBillDetailVo.billItemList != null) {
            let billList = res.result.omcOldManBillDetailVo.billItemList; //缴费类别
            let onceFee = 0;
            let totalFee = 0;
            let item = {};
            billList.map(item => {
              if (item.code == 3) {
                this.billItemList.push(item);
                onceFee = Number(onceFee) + Number(item.actualFee);
                totalFee = Number(totalFee) + Number(item.actualFee);
              } else {
                this.PeriodicItems.push(item);
              }
            });
            item.onceFee = onceFee;
            var data = {
              reviseDate: res.result.omcOldManBill.inDate
            };
            this.$post("omc/revise/queryReviseDays", data, "", "json").then(res => {
              if (res != null) {
                item.payDay = res.payDays;
                item.totalDay = res.cycleTotalDays;
                billList.map(item2 => {
                  if (item2.code<3 && item2.costType == 3) {
                    totalFee = Number(totalFee) + (Number(item2.actualFee) *  Number(res.payDays) / Number(res.cycleTotalDays));
                  }else if(item2.code<3 && item2.costType == 2) {
                    //按天扣费的 只扣到今天;
                    let date = new Date();
                    let day = date.getDate();
                    totalFee = Number(totalFee) + (Number(item2.actualFee) *  Number(day));
                  }
                });
                item.totalFee = totalFee.toFixed(2);
                this.totalFeeList.push(item);
              } 
            });
          }
          this.billInHospitalFee = [
            res.result.omcOldManBillDetailVo.billInHospitalFee
          ]; //入院费用账单统计
        }
        //请假账单
        if (this.billType == 5) {
          this.billDetail = res.result.omcOldManBillDetailVo;
          this.billDetail.intoDate = res.result.omcOldManBill.inDate;
          this.billDetail.newBedNo =res.result.oldLeaveVo.newBedNo;
          this.oldLeaveVo = res.result.oldLeaveVo;
          this.billDetail.createdDay =res.result.omcOldManBill.createdTime.split(" ")[0];
          this.totalFeeList = [];
          this.billItemList = [];
          if (res.result.omcOldManBillDetailVo.billItemList != null) {
            let billList = res.result.omcOldManBillDetailVo.billItemList; //缴费类别
            let item = {};
            billList.map(item => {
                this.billItemList.push(item);
            });
            item.payDay = res.result.oldLeaveVo.realRefundDays;
            item.totalDay = 30;
            item.totalFee = res.result.omcOldManBill.totalPay;
            item.leaveDate =  res.result.oldLeaveVo.leaveDate;
            item.returnDate =  res.result.oldLeaveVo.returnDate;
            this.billTotalFee =  res.result.omcOldManBill.totalPay;
            this.totalFeeList.push(item);
          }
          this.billInHospitalFee = [
            res.result.omcOldManBillDetailVo.billInHospitalFee
          ]; //入院费用账单统计
        }
        /* 
          出院
         */
        if (this.billType == 2) {
          this.billDetail = {
            billNumber: res.result.billNumber,
            oldName: res.result.oldOutVo.oldmanName,
            idCard: res.result.oldOutVo.idCard,
            newBedNo: res.result.oldOutVo.bedNo,
            cashPledgeNum: res.result.oldOutVo.inEpositNo,
            intoDate: res.result.omcOldManBill.inDate
          };
          this.oldOutVo = res.result.oldOutVo;
          this.totalFeeList = [];
          this.oldOutItemVoList = [];
          this.tuiFee = [];
          this.outTotal = [];
          if (res.result.omcOldManBillDetailVo.billItemList != null) {
            let billList = res.result.omcOldManBillDetailVo.billItemList; //缴费类别
            billList.forEach(item2 => {
              if (item2.modelCode == 6) {
                this.tuiFee.push(item2);
              } else{   
                this.oldOutItemVoList.push(item2);
              }
            });
            this.billTotalFee =  res.result.omcOldManBill.totalPay;
          }
          //合计
          this.outTotal.push({
            tuiDay: res.result.omcOldManBill.advanceCycle,
            itemsTotal: res.result.omcOldManBill.totalPay, //退费金额
            remainder: res.result.oldAccount!=null?res.result.oldAccount.remainder:0, //当前余额
            totalPay: (Number(res.result.oldAccount!=null?res.result.oldAccount.remainder:0)+Number(res.result.omcOldManBill.totalPay)).toFixed(2), //应缴合计
          });
          console.log(this.outTotal)
        }
        /* 周期 */
        if (this.billType == 4) {
          this.billDetail = {
            billNumber: res.result.omcOldManBill.billNumber,
            oldName: res.result.omcOldManBillDetailVo.oldName,
            idCard: res.result.omcOldManBillDetailVo.idCard,
            newBedNo: res.result.omcOldManBillDetailVo.newBedNo,
            cashPledgeNum: res.result.omcOldManBillDetailVo.cashPledgeNum,
            intoDate: res.result.omcOldManBill.inDate,
            sex: res.result.omcOldManBillDetailVo.sex
          };
          this.billPeriodFee = [res.result.omcOldManBillDetailVo.billPeriodFee];
          this.billItemList = res.result.omcOldManBillDetailVo.billItemList;
          this.billTypeName = res.result.omcOldManBillDetailVo.remark+""+this.billTypeName;
        }
        /* 
          调整账单
        */
        if (this.billType == 3) {
          this.billDetail = {
            billNumber: res.result.billNumber,
            oldName: res.result.reviseVo.oldmanName,
            idCard: res.result.reviseVo.idCard,
            newBedNo: res.result.reviseVo.reviseBedVoList[1].location,
            cashPledgeNum: res.result.omcOldManBill.cashPledgeNum,
            intoDate: res.result.omcOldManBill.inDate,
            createdDay: res.result.omcOldManBill.createdTime.split(" ")[0],
          };
          res.result.reviseVo.reviseItemVoList.forEach(item => {
            if (item.costType == 3){
              if (item.adjustOrder == 1) {
                this.billItemBeforeList.push(item); //调整前
              } else {
                this.billItemAfterList.push(item); //调整后
              }
            }
          });
          //调整账单
          let allList = [];
          res.result.reviseVo.reviseSetMealVoList.map(item => {
            item.reviseSetMealItemVoList.map(ele => {
              ele.name = item.setMealName;
            });
            allList.push(...item.reviseSetMealItemVoList);
          });
          this.billSetMealItemList = allList;
          this.billTotalFee = res.result.reviseVo.total;
          //应缴合计
          this.billAdjustFee = [
            {
              totalFee: res.result.reviseVo.total,
              payableFeeBalance: res.result.reviseVo.agio,
              payDay:res.result.reviseVo.payDays,
              totalDay:res.result.reviseVo.leaveDays,
            }
          ];
        }
      });
    }
  },
  created() {},
  mounted() {
    console.log(this.$route.query);
    this.billType = sessionStorage.getItem("detailBillType");
    this.billId = sessionStorage.getItem("detailBillId");
    this.billSex = sessionStorage.getItem("detailSex");
    this.oldManId = sessionStorage.getItem("detailOldId")
    this.getOldmanBillDetail(
      this.oldManId,
      this.billType,
      this.billId
    );
    this.billTypeName =
      this.billType == 1
        ? "入院办理项目清单详情"
        : this.billType == 2
        ? "出院退费费用结算详情"
        : this.billType == 3
        ? "调整账单费用结算详情"
        : this.billType == 4
        ? "月度账单费用明细详情"
        : this.billType == 5
        ? "请假退费结算详情"
        : "";
  }
};
</script>
<style lang="scss" scoped>
.admissionExpensesDetail {
  background: #fff;
  p {
    margin-top: 10px;
  }
  .react {
    width: 6px;
    height: 28px;
    background: #3a77e2;
    margin-left: 30px;
    margin-right: 20px;
  }
  .intoDetail {
    font-size: 16px;
    padding-top: 6px;
  }
  .baseDetail {
    border: 1px solid #e2e2e2;
    border-radius: 4px;
    margin-top: 50px;
    .header {
      display: flex;
      margin-top: 20px;
      background: #f9f7fa;
      font-size: 18px;
      align-items: center;
    }
  }
  .intoTime {
    border: 1px solid #e2e2e2;
    border-radius: 4px;
    margin-top: 50px;
    .header {
      display: flex;
      margin-top: 20px;
      background: #f9f7fa;
      font-size: 18px;
      align-items: center;
    }
  }
}
</style>
